import {
  useState,
  useEffect,
  useMemo,
  useCallback,
  startTransition,
} from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import jwt_decode from "jwt-decode";
import { isEmpty } from "lodash";
import AuthContext from "../../context/AuthContext";
import BetSlipContext from "../../context/BetSlipContext";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { categoryArray } from "../../Utils/constants";
import { isMobile } from "react-device-detect";
import { useMatchSocket } from "../hooks/useMatchSocket";
import { useTranslation } from "react-i18next";
export const useMatchDetailLogic = () => {
  const { t } = useTranslation();
  let Show = {
    sportsBook: process.env.REACT_APP_SHOW_SPORTSBOOK === "true",
    fancy: process.env.REACT_APP_SHOW_FANCY === "true",
  };
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const profileData = useContextSelector(AuthContext, (ctx) => ctx.profileData);
  const setSocketId = useContextSelector(AuthContext, (ctx) => ctx.setSocketId);
  const scoreAll = useContextSelector(AuthContext, (ctx) => {
    return ctx.scoreAll;
  });
  const setTv = useContextSelector(AuthContext, (ctx) => ctx.setTv);
  const tv = useContextSelector(AuthContext, (ctx) => ctx.tv);
  const showBetDialog = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.showBetDialog,
  );
  const toastObject = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.toastObject,
  );
  const setToastObject = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.setToastObject,
  );
  const betPlace = useContextSelector(BetSlipContext, (ctx) => ctx.betPlace);
  const resetBetPosition = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.resetBetPosition,
  );
  const betSlipObject = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.betSlipObject,
  );
  const setBetSlipObject = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.setBetSlipObject,
  );
  const setResetBetPosition = useContextSelector(
    BetSlipContext,
    (ctx) => ctx.setResetBetPosition,
  );

  // ------------------ State ------------------
  const [fancyModal, setFancyModal] = useState({ status: false, object: {} });
  const [loading, setLoading] = useState(true);
  const [mute, setMute] = useState(true);
  const [tvClass, setTvClass] = useState(false);
  const [fancyTab, setFancyTab] = useState("Fancy");
  const [marketNew, setMarketNew] = useState([]);
  const [marketName, setMarketName] = useState("Match Odds");
  const [marketId, setMarketId] = useState("");
  const [activeTab, setActiveTab] = useState("live");
  const [position, setPosition] = useState([]);
  const [detail, setDetail] = useState({});
  const [bookmakerOdds, setBookmakerOdds] = useState([]);
  const [sportsBookPosition, setSportsBookPosition] = useState([]);
  const [bookmaker, setBookmaker] = useState([]);
  const [fancy, setFancy] = useState([]);
  const [sportsBook, setSportsBook] = useState([]);
  const [fancyPosition, setFancyPosition] = useState([]);
  const [runner, setRunner] = useState([]);
  const [runnerOdds, setRunnerOdds] = useState([]);
  const [fancyHeader, setFancyHeader] = useState([]);
  const [favouriteList, setFavouriteList] = useState([]);
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  let loc = location?.pathname?.split("/");

  const parmas = useParams();
  const navigate = useNavigate();
  const reorderMarkets = (markets) => {
    const matchOddsIndex = markets.findIndex(
      (market) => market.market === "Match Odds",
    );

    if (matchOddsIndex > 0) {
      const matchOddsMarket = markets.splice(matchOddsIndex, 1)[0];
      markets.unshift(matchOddsMarket);
    }

    return [...markets];
  };

  useMatchSocket({
    detail,
    user,
    parmas,
    Show,
    handlers: {
      onBetfairOdds: (event) => {
        if (!event?.results?.length) return;

        if (loc[1] === "match-detail-sky" && !isMobile) {
          const socket_data = event.results;
          setMarketNew((prev) => {
            const updated = [...prev];
            socket_data.forEach((sock) => {
              const index = updated.findIndex((m) => m.marketId === sock.mi);
              if (index === -1) return;
              const oldOdds = updated[index].odds ?? {};
              updated[index] = {
                ...updated[index],
                odds: {
                  back_odds: sock.rt?.filter((rt) => rt.ib) ?? [],
                  lay_odds: sock.rt?.filter((rt) => !rt.ib) ?? [],
                  back_odds_old: oldOdds.back_odds ?? [],
                  lay_odds_old: oldOdds.lay_odds ?? [],
                  ms: sock.ms,
                  totalMatched: sock.totalMatched,
                },
              };
            });
            return updated;
          });
        } else {
          const find = event.results.find((r) => r.mi === marketId);
          if (!find?.rt?.length) return;
          const back_odds = find.rt.filter((rt) => rt.ib);
          const lay_odds = find.rt.filter((rt) => !rt.ib);
          setRunnerOdds((prev) => ({
            back_odds,
            back_odds_old: prev?.back_odds,
            lay_odds_old: prev?.lay_odds,
            lay_odds,
            ms: find.ms,
            totalMatched: find.totalMatched,
          }));
        }
      },

      onBookmakerOdds: (message) => {
        if (message?.eventId !== parmas?.eventId) return;
        if (message?.results?.rt?.length > 0) {
          const back_odds = message?.results?.rt?.filter((rt) => rt.ib);
          const lay_odds = message?.results?.rt?.filter((rt) => !rt.ib);
          setBookmakerOdds((prev) => ({
            back_odds,
            back_odds_old: prev?.back_odds,
            lay_odds_old: prev?.lay_odds,
            lay_odds,
            ms: message.ms ?? 1,
          }));
        }
      },

      onDiamondFancy: (message) => {
        if (message?.eventId !== parmas?.eventId) return;
        if (message?.results?.length > 0) {
          updateFancyOdds(message);
        }
      },

      onPremiumFancy: (message) => {
        if (message.eventId !== parmas.eventId) return;
        setSportsBookPosition((prev) => {
          setSportsBook((current) => {
            const data =
              message.results?.length > 0
                ? message.results
                : current.map((res) => ({
                    ...res,
                    apiSiteStatus: "SUSPENDED",
                  }));

            return data.map((res) => {
              const obj =
                prev?.length > 0
                  ? prev?.filter((item) => item.fancyName === res.marketName)
                  : {};
              if (obj.length > 0 && obj[0].fancyName === res.marketName) {
                return {
                  ...res,
                  sportsBookSelection: res.sportsBookSelection.map((elem) => {
                    const temp = obj.find(
                      (item) => elem.id === item.fancySelectionId,
                    );
                    return { ...elem, position: temp?.position };
                  }),
                };
              }
              return res;
            });
          });
          return prev;
        });
      },

      // ── Expose socket id to AuthContext ─────────────────────────
      onSocketCreated: (socket) => {
        setSocketId(socket);
      },
    },
  });
  // ------------------ Core Functions ------------------
  const getMatchDetails = useCallback(
    async (info) => {
      if (isEmpty(info)) {
        setLoader(true);
      }
      let userId = !isEmpty(localStorage.getItem("token"))
        ? jwt_decode(localStorage.getItem("token"))?.user?._id
        : "";
      let obj = !isEmpty(parmas?.eventType)
        ? {
            userId: userId,
            eventId: parmas?.eventId,
            marketId: parmas?.marketId,
            eventType: parmas?.eventType,
          }
        : {
            userId: userId,
            eventId: parmas?.eventId,
            marketId: parmas?.marketId,
          };
      const { status, data: response_users } = await apiGet(
        apiPath.matchDetail,
        obj,
      );
      if (status === 200) {
        if (response_users?.success) {
          if (response_users?.results?.resultStatus) {
            navigate("/");
          }
          if (
            !isEmpty(userId) &&
            response_users?.results?.status == "in_play"
          ) {
            setActiveTab("live");
          } else {
            setActiveTab("scoreboard");
          }
          if (
            !["horse", "greyhound"].includes(parmas?.type) &&
            !isEmpty(userId) &&
            response_users?.results?.status == "in_play"
          ) {
            setTv({ status: false, show: true });
          } else {
            setTv({ status: false, show: false });
          }
          if (["horse", "greyhound"].includes(parmas?.type)) {
            if (response_users?.results?.marketList?.length > 0) {
              let find = response_users?.results?.marketList?.find((res) => {
                return res?.marketId == parmas?.marketId;
              });
              setMarketNew([find]);
              setMarketId(find[0]?.marketId);
              setRunner(find[0]?.jsonData || []);
              setMarketName(find[0]?.market);
            }
          } else {
            if (response_users?.results?.marketList?.length > 0) {
              let matchList = reorderMarkets(
                response_users?.results?.marketList,
              );
              setMarketNew(matchList || []);
              setMarketId(matchList[0]?.marketId);
              setRunner(matchList[0]?.jsonData || []);
              setMarketName(matchList[0]?.market);
            } else if (response_users?.results?.jsonData?.length > 0) {
              let json = {
                market: "Match Odds",
                marketId: response_users?.results?.marketId,
                jsonData: response_users?.results?.jsonData,
              };
              setMarketNew(json || []);
              setMarketId(response_users?.results?.marketId);
              setRunner(response_users?.results?.jsonData || []);
              setMarketName("Match Odds");
            }
          }
          setDetail(response_users?.results);
          setFancyTab((prev) => {
            if (info) {
              return prev;
            } else {
              if (response_users?.results?.eventType == 4) {
                if (response_users?.results?.hasFancy) {
                  return "Fancy";
                } else {
                  return "Premium";
                }
              } else {
                return "Premium";
              }
            }
          });
          setFavouriteList(
            response_users?.results?.favourites?.map((res) => {
              return res?.favoriteMarketId;
            }),
          );
          if (response_users?.results?.jsonBookmakerData?.length > 0) {
            setBookmaker(
              response_users?.results?.jsonBookmakerData?.map((res) => {
                let id = response_users?.results?.jsonData?.find((item) => {
                  return (
                    item?.RunnerName?.toLowerCase() ==
                    res?.runnerName?.toLowerCase()
                  );
                });
                return {
                  ...res,
                  selectionID: id?.SelectionId,
                  SelectionId: id?.SelectionId,
                  runnerName: id?.RunnerName,
                };
              }) || [],
            );
          } else {
            setBookmaker(response_users?.results?.jsonData || []);
          }
        }
      }
      setLoader(false);
    },
    [parmas, user],
  );

  const getSportBookList = useCallback(async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.getPremiumFancy + `?eventId=${parmas.eventId}`,
    );
    if (response_users.success) {
      let filtered =
        response_users?.results?.data?.length > 0
          ? response_users?.results?.data?.filter((res) => {
              return res?.sportsBookSelection?.length > 0;
            })
          : [];
      setSportsBook(filtered);
    }
  }, [parmas.eventId]);

  const getFancyData = useCallback(async () => {
    const { status, data: message } = await apiGet(
      apiPath.getFancyOdds + `?eventId=${parmas.eventId}`,
    );
    if (message.success) {
      if (message?.results?.length > 0) {
        updateFancyOdds(message);
      }
    }
  }, [parmas.eventId]);

  const getBetPosition = useCallback(
    async (id, game) => {
      const string =
        loc[1] == "match-detail-sky" && !isMobile
          ? `?eventId=${parmas?.eventId}&type=${
              game || detail?.gameType
            }&marketId=${marketNew
              ?.map((res) => {
                return res?.marketId;
              })
              ?.join(",")}&multi=true`
          : detail?.market === "Winner"
            ? `?marketId=${id}`
            : `?eventId=${parmas.eventId}&type=${
                game || detail?.gameType
              }&marketId=${id}`;

      const { status, data: response } = await apiGet(
        apiPath.betPosition + string,
      );
      if (!response?.success) return;
      const result = response?.results;
      setPosition(result);
      if (result?.betFair?.length > 0) {
        if (loc[1] == "match-detail-sky" && !isMobile) {
          let positions = result?.betFair;
          setMarketNew((prev) => {
            if (!prev) return prev;

            // clone array only (keep inner objects stable)
            const updated = [...prev];

            positions.forEach((pos) => {
              const selectionId = String(pos.selectionId);

              // Check ALL markets
              updated.forEach((market) => {
                if (!market.jsonData) return;

                // Find matching runner inside jsonData
                const runnerIndex = market.jsonData.findIndex(
                  (r) => String(r.SelectionId) === selectionId,
                );

                if (runnerIndex !== -1) {
                  const runner = market.jsonData[runnerIndex];

                  // Update ONLY the position key (this avoids blinking)
                  market.jsonData[runnerIndex] = {
                    ...runner,
                    position: pos.position,
                  };
                }
              });
            });

            return updated;
          });
        } else {
          setRunner((current) =>
            current.map((res) => {
              const obj = result.betFair.find(
                (item) =>
                  Number(item?.selectionId) === Number(res?.SelectionId),
              );
              return {
                ...res,
                position: obj?.position || 0,
                newPosition: 0,
              };
            }),
          );
        }
      }

      const bookmakerList = result?.bookmaker || [];
      if (bookmakerList.length > 0) {
        setBookmaker((current) =>
          current.map((res) => {
            const obj = bookmakerList?.find(
              (item) => Check(item) == res?.SelectionId,
            );
            return {
              ...res,
              position: obj?.position || 0,
              newPosition: 0,
            };
          }),
        );
      }
    },
    [parmas.eventId, detail?.market, detail?.gameType],
  );

  const Check = (item) => {
    return item?.selectionId.startsWith("B")
      ? item?.selectionId.slice(1)
      : item?.selectionId;
  };
  const getFancyBetPosition = useCallback(async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.betFancyPosition +
        `?eventId=${parmas.eventId}&type=${detail.gameType}`,
    );
    if (status === 200) {
      if (response_users.success) {
        updatedFancyPosition(
          response_users?.results?.map((res) => {
            return {
              selectionId: res?.selectionId,
              position: res?.position,
              betRunPosition: res?.betRunPosition,
              fName: res?.fancyName,
            };
          }),
        );
      }
    }
  }, [parmas.eventId, detail?.gameType]);
  const updatedFancyPosition = (object) => {
    setFancyPosition(object);
    setFancy((prev) => {
      return (
        prev &&
        prev.length > 0 &&
        prev?.map((res) => {
          let obj = object?.find((item) => item.selectionId == res.selectionId);
          return {
            ...res,
            odds: res,
            position: !isEmpty(obj) ? obj?.position : "",
          };
        })
      );
    });
  };
  const getSportBookBetPosition = useCallback(async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.betPremiumFancyPosition +
        `?eventId=${parmas.eventId}&type=${detail.gameType}`,
    );
    if (status === 200) {
      if (response_users.success) {
        setSportsBookPosition(response_users?.results);
        setSportsBook((current) => {
          return current?.map((res) => {
            let obj = response_users?.results?.filter((item) => {
              return item?.fancyName == res?.marketName;
            });
            if (obj?.length > 0 && obj[0]?.fancyName == res?.marketName) {
              return {
                ...res,
                sportsBookSelection: res?.sportsBookSelection?.map((elem) => {
                  let temp = obj?.find(
                    (item) => elem?.id == item?.fancySelectionId,
                  );
                  return {
                    ...elem,
                    position: temp?.position,
                  };
                }),
              };
            } else {
              return res;
            }
          });
        });
      }
    }
  }, [parmas.eventId, detail?.gameType]);

  const listenBookmakerData = useCallback(
    (message) => {
      if (message?.eventId === parmas?.eventId) {
        let socket_data = message;
        if (!isEmpty(socket_data)) {
          if (socket_data.rt?.length > 0) {
            const back_odds = socket_data.rt.filter((rt) => rt.ib) || [];
            const lay_odds = socket_data.rt.filter((rt) => !rt.ib) || [];
            setBookmakerOdds((prev) => {
              return {
                back_odds: back_odds,
                back_odds_old: prev?.back_odds,
                lay_odds_old: prev?.lay_odds,
                lay_odds: lay_odds,
                ms: socket_data?.ms || 1,
              };
            });
          }
        }
      }
    },
    [parmas.eventId],
  );

  const updateFancyOdds = useCallback(
    (message) => {
      let filtered = categoryArray?.filter((f) =>
        message?.results?.some((item) => item?.categoryType === f.type),
      );
      setFancyHeader(
        filtered?.length > 0
          ? [
              { type: "All", name: "All" },
              // { type: "Ball", name: "Ball/Ball" },
              // { type: "WP", name: "W/P" },

              // { type: "OddEven", name: "ODD/EVEN" },
              ...filtered,
            ]
          : [
              { type: "All", name: "All" },
              // { type: "Ball", name: "Ball/Ball" },
              // { type: "WP", name: "W/P" },
              // { type: "OddEven", name: "ODD/EVEN" },
            ],
      );
      if (!isEmpty(user)) {
        setFancyPosition((prev) => {
          setFancy(
            message?.results?.map((res) => {
              let obj = prev?.find(
                (item) => item.selectionId == res.selectionId,
              );

              return {
                ...res,
                odds: res,
                fancyName: res.name,
                position: !isEmpty(obj) ? obj?.position : "",
                newPosition:
                  Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
              };
            }),
          );

          return prev;
        });
      } else {
        setFancy((prev) => {
          return message?.results?.map((res) => {
            let obj = prev?.find((item) => item.selectionId == res.selectionId);
            return {
              ...res,
              odds: res,
              fancyName: res.name,
              position: !isEmpty(obj) ? obj?.position : "",
              newPosition:
                Math.abs(obj?.newPosition) > 0 ? obj?.newPosition : "",
            };
          });
        });
      }
    },
    [user],
  );

  // ------------------ Helpers ------------------
  const resetPosition = useCallback((type) => {
    if (type == "bookmaker") {
      setBookmaker((current) =>
        current?.map((res) => {
          return {
            ...res,
            position: Math.abs(res?.position) > 0 ? res?.position : 0,
            newPosition: 0,
          };
        }),
      );
    } else if (type == "betFaire") {
      setRunner((current) =>
        current?.map((res) => {
          return {
            ...res,
            position: Math.abs(res?.position) > 0 ? res?.position : 0,
            newPosition: 0,
          };
        }),
      );
    }
    setResetBetPosition(false);
    setBetSlipObject({});
  }, []);

  const calculateNewPositions = (runners, slipObj, betSlipObject) => {
    let arr = runners.map((r) => ({
      ...r,
      position: r.position || 0,
      newPosition: r.newPosition || 0,
    }));

    const isBack = slipObj?.object?.ib;
    const selectionId = slipObj?.object?.ri;

    const stake = Number(betSlipObject?.bidPrice);
    const odds = Number(betSlipObject?.odds);

    if (stake > 0) {
      if (isBack) {
        const profit = (odds - 1) * stake;
        const loss = stake;

        arr = arr.map((r) => {
          if (r.SelectionId == selectionId) {
            return { ...r, newPosition: r.position + profit };
          }
          return { ...r, newPosition: r.position - loss };
        });
      } else {
        const profit = stake;
        const loss = (odds - 1) * stake;

        arr = arr.map((r) => {
          if (r.SelectionId == selectionId) {
            return { ...r, newPosition: r.position - loss };
          }
          return { ...r, newPosition: r.position + profit };
        });
      }
    }

    return arr;
  };

  const handelBetFairPositions = useCallback(
    (slipObj) => {
      let selectionsTemp = runner?.map((item) => {
        return {
          ...item,
          position: item?.position || 0,
          newPosition: item?.newPosition || 0,
        };
      });
      let newArray = selectionsTemp;
      if (betSlipObject?.bidPrice > 0) {
        if (slipObj?.object?.ib) {
          let backProfit = Number(
            Number(betSlipObject.odds - 1) * Number(betSlipObject?.bidPrice),
          );
          let backLoss = Number(betSlipObject?.bidPrice);
          if (Math.abs(newArray[0]?.position) > 0) {
            newArray = newArray?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + backProfit,
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - backLoss,
                };
              }
            });
          } else {
            newArray = newArray?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              } else {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              }
            });
          }
        } else {
          let backProfit = Number(betSlipObject?.bidPrice);
          let backLoss =
            Number(betSlipObject.odds - 1) * Number(betSlipObject?.bidPrice);
          if (Math.abs(newArray[0]?.position) > 0) {
            newArray = newArray?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: Number(rl.position) - backLoss,
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(rl.position) + backProfit,
                };
              }
            });
          } else {
            newArray = newArray?.map((rl) => {
              if (rl.SelectionId == slipObj?.object?.ri) {
                return {
                  ...rl,
                  newPosition: -Number(backLoss),
                };
              } else {
                return {
                  ...rl,
                  newPosition: Number(backProfit),
                };
              }
            });
          }
        }
      }
      setRunner(newArray);
    },
    [runner, betSlipObject],
  );

  const handelBetFairPositionsMarket = useCallback(
    (slipObj) => {
      setMarketNew((prev) => {
        const updated = [...prev];

        const targetMarketId = slipObj?.newMarketId; // MARKET ID

        const marketIndex = updated.findIndex(
          (m) => m.marketId == targetMarketId,
        );

        if (marketIndex === -1) return prev;

        const market = updated[marketIndex];

        // Calculate new positions using SAME LOGIC as before
        const newRunnerPositions = calculateNewPositions(
          market.jsonData,
          slipObj,
          betSlipObject,
        );

        // Replace only updated runners
        updated[marketIndex] = {
          ...market,
          jsonData: newRunnerPositions,
        };

        return updated;
      });
    },
    [betSlipObject],
  );

  const handelBookmakerPositions = useCallback(
    (slipObj) => {
      let selectionsTemp = [...bookmaker]?.map((res) => {
        return {
          ...res,
          position: res?.position || 0,
          newPosition: res?.newPosition || 0,
        };
      });
      if (slipObj?.bidPrice > 0) {
        if (slipObj?.object.ib) {
          let backProfit = Number((slipObj?.odds / 100) * slipObj?.bidPrice);
          let backLoss = Number(slipObj?.bidPrice);
          if (Math.abs(selectionsTemp[0]?.position) > 0) {
            setBookmaker(
              selectionsTemp?.map((rl) => {
                if (rl.SelectionId == slipObj?.object?.SelectionId) {
                  return {
                    ...rl,
                    newPosition: Number(rl.position) + Number(backProfit),
                  };
                } else {
                  return {
                    ...rl,
                    newPosition: Number(rl.position) - Number(backLoss),
                  };
                }
              }),
            );
          } else {
            let backProfit = Number((slipObj?.odds / 100) * slipObj?.bidPrice);
            let backLoss = Number(slipObj?.bidPrice);

            setBookmaker(
              selectionsTemp?.map((rl) => {
                if (rl.SelectionId == slipObj?.object?.SelectionId) {
                  return {
                    ...rl,
                    newPosition: Number(backProfit),
                  };
                } else {
                  return {
                    ...rl,
                    newPosition: -Number(backLoss),
                  };
                }
              }),
            );
          }
        } else {
          if (Math.abs(selectionsTemp[0]?.position) > 0) {
            let backProfit = Number(slipObj?.bidPrice);
            let backLoss = Number((slipObj?.odds / 100) * slipObj?.bidPrice);

            setBookmaker(
              selectionsTemp?.map((rl) => {
                if (rl.SelectionId == slipObj?.object?.SelectionId) {
                  return {
                    ...rl,
                    newPosition: Number(rl.position) - Number(backLoss),
                  };
                } else {
                  return {
                    ...rl,
                    newPosition: Number(rl.position) + Number(backProfit),
                  };
                }
              }),
            );
          } else {
            let backProfit = Number(slipObj?.bidPrice);
            let backLoss = Number((slipObj?.odds / 100) * slipObj?.bidPrice);
            setBookmaker(
              selectionsTemp?.map((rl) => {
                if (rl.SelectionId == slipObj?.object?.SelectionId) {
                  return {
                    ...rl,
                    newPosition: -Number(backLoss),
                  };
                } else {
                  return {
                    ...rl,
                    newPosition: Number(backProfit),
                  };
                }
              }),
            );
          }
        }
      }
    },
    [bookmaker],
  );
  const getMatchOdds = useCallback(
    async (id, marketNew) => {
      let string =
        loc[1] == "match-detail-sky" && !isMobile
          ? `?marketId=${marketNew
              ?.map((res) => {
                return res?.marketId;
              })
              ?.join(",")}&multi=true&eventId=${parmas?.eventId}`
          : `?marketId=${id}&eventId=${parmas?.eventId}`;
      const { status, data: response_users } = await apiGet(
        apiPath.getMatchOdds + string,
      );

      if (response_users.success) {
        if (loc[1] == "match-detail-sky" && !isMobile) {
          const socket_data = response_users?.data;
          setMarketNew((prev) => {
            // Clone only the array, NOT each object
            const updated = [...prev];

            socket_data?.forEach((sock) => {
              const index = updated.findIndex((m) => m.marketId === sock.mi);
              if (index !== -1) {
                // ONLY update the odds object, not the entire market row
                updated[index] = {
                  ...updated[index],
                  odds: {
                    back_odds: sock?.rt?.filter((rt) => rt.ib) || [],
                    lay_odds: sock?.rt?.filter((rt) => !rt.ib) || [],
                    ms: sock?.ms,
                    totalMatched: sock?.totalMatched,
                  },
                };
              }
            });

            return updated;
          });
        } else {
          const socket_data = response_users?.results;
          if (
            socket_data &&
            socket_data?.eventId &&
            parmas?.eventId == socket_data?.eventId
          ) {
            if (socket_data.rt?.length) {
              const back_odds = socket_data.rt.filter((rt) => rt.ib) || [];
              const lay_odds = socket_data.rt.filter((rt) => !rt.ib) || [];
              setRunnerOdds({
                back_odds: back_odds,
                lay_odds: lay_odds,
                ms: socket_data?.ms,
                totalMatched: socket_data?.totalMatched,
              });
            }
          }
        }
      }
    },
    [parmas?.eventId],
  );

  const getBookmakerOdds = useCallback(async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.bookmakerOdds + `?eventId=${parmas.eventId}`,
    );
    if (status === 200) {
      if (response_users.success) {
        const message = response_users?.results;

        listenBookmakerData(message);
      }
    }
  }, [parmas.eventId]);

  const addToFavioute = useCallback(
    async (id, favoriteType, favoriteMarketId, market) => {
      if (isEmpty(user)) {
        setToastObject({
          type: "warning",
          title: t("Warning"),
          message: t("PleaseLoginToAddFavourite"),
          status: true,
        });
        return;
      } else {
        const { status, data: response_users } = await apiGet(
          apiPath.addToFavourite +
            `?eventId=${id}&favoriteType=${favoriteType}&favoriteMarketId=${favoriteMarketId}&eventType=${
              detail?.eventType
            }&market=${market ? market : ""}`,
        );

        if (response_users?.success) {
          getMatchDetails("fav");
        }
      }
    },
    [detail?.eventType],
  );
  useEffect(() => {
    if (
      !isEmpty(marketId) &&
      parmas?.type !== "multi" &&
      marketNew?.length > 0
    ) {
      getMatchOdds(marketId, marketNew);
    }
  }, [marketId, parmas?.type]);
  useEffect(() => {
    if (!isEmpty(detail)) {
      getBookmakerOdds();
    }
  }, [detail]);

  useEffect(() => {
    getMatchDetails();
    if (isEmpty(parmas?.eventType)) {
      if (
        !["horse", "greyhound", "multi"].includes(parmas?.type) &&
        Show?.fancy
      ) {
        getFancyData();
      }
      if (!["horse", "greyhound"].includes(parmas?.type) && Show?.sportsBook) {
        getSportBookList();
      }
    }
  }, [parmas]);
  useEffect(() => {
    if (resetBetPosition) {
      resetPosition(betSlipObject?.playType);
    }
  }, [resetBetPosition]);

  useEffect(() => {
    if (!isEmpty(user) && !isEmpty(detail)) {
      startTransition(() => {
        if (!["multi"].includes(parmas?.type)) {
          getBetPosition(marketId, "", marketNew);
        }
        if (isEmpty(parmas?.eventType)) {
          if (!["horse", "greyhound", "multi"].includes(parmas?.type)) {
            if (
              detail?.hasFancy &&
              !["Winner", "Win"].includes(detail?.market) &&
              detail?.gameType === "cricket" &&
              Show?.fancy
            ) {
              getFancyBetPosition();
            }
            if (
              (detail?.premiumFancy === "on" || detail?.hasSportBook) &&
              Show?.sportsBook
            ) {
              getSportBookBetPosition();
            }
          }
        }
      });
    }
  }, [detail, marketId, parmas]);
  useEffect(() => {
    if (showBetDialog) {
      if (!isEmpty(betSlipObject)) {
        if (betSlipObject?.playType == "betFaire") {
          if (loc[1] == "match-detail-sky" && !isMobile) {
            handelBetFairPositionsMarket(betSlipObject);
          } else {
            handelBetFairPositions(betSlipObject);
          }
        } else if (betSlipObject?.playType == "bookmaker") {
          handelBookmakerPositions(betSlipObject);
        }
      }
    }
  }, [betSlipObject, showBetDialog]);

  useEffect(() => {
    if (betPlace?.isPlaced && betPlace?.type == "matched") {
      if (betPlace?.betType == "fancy") {
        getFancyBetPosition();
      } else if (betPlace?.betType == "sportBook") {
        getSportBookBetPosition();
      } else {
        getBetPosition(marketId, "", marketNew);
      }
    } else if (betPlace?.isPlaced && betPlace?.type == "error") {
      resetPosition(betPlace?.betType);
    }
  }, [betPlace, marketId]);

  // ------------------ Memoized Values ------------------
  const totalMatched = useMemo(
    () => (runnerOdds?.totalMatched > 0 ? runnerOdds?.totalMatched : 0),
    [runnerOdds?.totalMatched],
  );
  const backOdds = useMemo(
    () => (detail?.matchOdds === "on" ? runnerOdds?.back_odds || [] : []),
    [detail?.matchOdds, runnerOdds?.back_odds],
  );
  const layOdds = useMemo(
    () => (detail?.matchOdds === "on" ? runnerOdds?.lay_odds || [] : []),
    [detail?.matchOdds, runnerOdds?.lay_odds],
  );
  const backOddsBookmaker = useMemo(
    () => (detail?.bookMaker === "on" ? bookmakerOdds?.back_odds || [] : []),
    [detail?.bookMaker, bookmakerOdds?.back_odds],
  );
  const layOddsBookmaker = useMemo(
    () => (detail?.bookMaker === "on" ? bookmakerOdds?.lay_odds || [] : []),
    [detail?.bookMaker, bookmakerOdds?.lay_odds],
  );
  const oldBack = useMemo(
    () => (detail?.matchOdds === "on" ? runnerOdds?.back_odds_old || [] : []),
    [detail?.matchOdds, runnerOdds?.back_odds_old],
  );
  const oldLay = useMemo(
    () => (detail?.matchOdds === "on" ? runnerOdds?.lay_odds_old || [] : []),
    [detail?.matchOdds, runnerOdds?.lay_odds_old],
  );
  const oldBackBookmaker = useMemo(
    () => (detail?.bookMaker === "on" ? runnerOdds?.back_odds_old || [] : []),
    [detail?.bookMaker, runnerOdds?.back_odds_old],
  );
  const oldLayBookmaker = useMemo(
    () => (detail?.bookMaker === "on" ? bookmakerOdds?.lay_odds_old || [] : []),
    [detail?.bookMaker, bookmakerOdds?.lay_odds_old],
  );
  const ms = useMemo(
    () => (!isEmpty(runnerOdds) ? runnerOdds?.ms : 3),
    [runnerOdds],
  );
  const positionMemo = useMemo(
    () => position?.betFair || [],
    [position?.betFair],
  );
  const positionMemoBookmaker = useMemo(
    () => position?.bookmaker || [],
    [position?.bookmaker],
  );

  const profileDataMemo = useMemo(() => {
    if (detail?.matchSetting?.length > 0) {
      return { ...detail, arrayCheck: "details", profile: profileData };
    }
    return { ...profileData, arrayCheck: "profile", profile: profileData };
  }, [detail, profileData]);

  let showFancy =
    detail?.hasFancy &&
    !["Winner", "Win"].includes(detail?.market) &&
    detail?.gameType === "cricket" &&
    Show?.fancy;
  let showSportbook =
    !isEmpty(user) &&
    (detail?.premiumFancy === "on" || detail?.hasSportBook) &&
    Show?.sportsBook;

  const matchedScore = scoreAll?.find(
    (res) => res?.eventId === detail?.eventId,
  );
  const score = matchedScore?.score ?? detail?.outcome ?? "";

  // ------------------ Return Everything ------------------
  return {
    // context
    user,
    profileData,
    showBetDialog,
    toastObject,
    setToastObject,
    betSlipObject,
    setBetSlipObject,

    // state
    fancyModal,
    setFancyModal,
    loading,
    setLoading,
    mute,
    setMute,
    tvClass,
    setTvClass,
    fancyTab,
    setFancyTab,
    setMarketName,
    marketNew,
    setMarketNew,
    marketName,
    marketId,
    setMarketId,
    detail,
    bookmakerOdds,

    sportsBookPosition,
    bookmaker,
    fancy,
    sportsBook,
    fancyPosition,

    runner,
    setRunner,
    runnerOdds,
    fancyHeader,
    favouriteList,
    loader,

    // functions
    getBetPosition,
    getMatchOdds,
    addToFavioute,
    getMatchDetails,

    // memoized
    totalMatched,
    backOdds,
    layOdds,
    backOddsBookmaker,
    layOddsBookmaker,
    oldBack,
    oldLay,
    oldBackBookmaker,
    oldLayBookmaker,
    ms,
    positionMemo,
    positionMemoBookmaker,
    profileDataMemo,
    showFancy,
    showSportbook,

    activeTab,
    setActiveTab,
    score,
    setTv,
    tv,
  };
};
